import {
  useWSModal,
  WSForm,
  WSInputText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { useWSMutation } from "../../../../../query/helpers";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../../../query/users/queries";
import { entityDataService } from "../../../../../shared/services/entityData";
import { validatorEmail } from "../../../../../shared/validators/validatorEmail";
import { WSServiceError } from "../../../../../utils/serviceHelper";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: string };

type Props = {
  onClose: () => void;
};

export const FormEditSupportEmail: React.FC<Props> = props => {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);

  const [mutate, meta] = useWSMutation<void, WSServiceError, FormData>(
    async data => {
      await entityDataService.updateEntity(
        {
          email: data.newValue
        },
        {
          userId
        }
      );
    },
    {
      onSuccess: props.onClose
    }
  );

  return (
    <WSForm<FormData>
      defaultValues={{
        newValue: queryMember.data?.profile.company?.supportEmail || ""
      }}
      onSubmit={mutate}
      validationSchema={Yup.object({
        newValue: validatorEmail
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <WSForm.Field
          name="newValue"
          label="Support email (optional)"
          component={WSInputText}
        />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditSupportEmail = () =>
  useWSModal(FormEditSupportEmail, {
    title: "Support email",
    size: "S"
  });
